import { topicsData } from '@/mocks/homeData';

export default function SectionTopics() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">热门话题</h2>
          <p className="text-sm text-foreground-500 mt-2">大家都在讨论的电视剧话题，加入追剧大家庭</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topicsData.map((topic) => (
            <div
              key={topic.name}
              className={`group flex items-center gap-3 px-5 py-3 rounded-full cursor-pointer transition-all duration-300 hover:scale-105 ${
                topic.hot
                  ? 'bg-primary-500 text-white'
                  : 'bg-background-100 text-foreground-700 hover:bg-accent-100 hover:text-accent-900'
              }`}
            >
              {topic.hot && (
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-fire-fill text-accent-400 text-sm"></i>
                </span>
              )}
              <span className="text-sm font-medium whitespace-nowrap">{topic.name}</span>
              <span className={`text-xs whitespace-nowrap ${topic.hot ? 'text-white/70' : 'text-foreground-400'}`}>
                {topic.count}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}